import React from "react";
import {Link} from "react-router-dom";

import {Button} from "reactstrap";
import ReactTable from "react-table";
import moment from "moment";

import Framework from "@beardeddevops/react.framework";
import APPCONFIG from "../constants/Config";
import {Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import CollectionOverride from "components/CollectionOverride";


const {getFullID} = Framework.Utilities;

export default class TransactionCollection extends CollectionOverride {

	constructor(props, model) {
		super(props, model);
		this.state.limit = 20;
		this.state.columnsAnchor = null;
		this.model.sort = 'pkey';
		this.state.code = null;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		//if we need to push history to self, then this will reload the data
		if(this.props.history.location.search === "?reload=True"){
			//reload the collection table
			this.reloadTable();
			//remove the search, that way it doesn't show up in the URL
			this.props.history.push({
				search: ""
			});
		}
	}

	toggle = (name) => () => {
		this.handleClose();
		this.setState({[name]: !this.state[name]});
	};

	tableColumns = (type, url) => [
		{
			Header: "Transaction",
			accessor: "transaction",
			width: 190,
			/**
			 * @param {Transactions_Object} props.original
			 * @returns {JSX.Element}
			 */
			Cell: props => {
				//this upsets me that canceled has two l's here -Kendall 
				if(props.original.cancelled) {
					return(
					<Link
						to={"/" + url + "/" + props.original.collection_binary_id + '-' + props.original.collection}>
						{(props.original.manual_4473 || props.original.transaction || (props.original.collection_binary_id + '-' + props.original.collection)) + '-CANCELLED'}
					</Link>
					)
				}
				else {
					return(
					<Link
						to={"/" + url + "/" + props.original.collection_binary_id + '-' + props.original.collection}>
						{props.original.manual_4473 || props.original.transaction || (props.original.collection_binary_id + '-' + props.original.collection)}
					</Link>
					)
				}
			}
		},
		{
			Header: "Pawn Inventory",
			accessor: "pawn_inventory",
			width: 140,
			show: ["Pawns"].includes(type),
		},
		{
			Header: "Pawn Ticket",
			accessor: "pawn_ticket",
			width: 140,
			show: ["Pawns"].includes(type),
		},
		{
			Header: "Country of Origin",
			id: 'country_of_origin',
			width: 160,
			accessor: object => {
				/** @type {Transactions_Collections_Object} object*/
				return object?.importers?.country_of_origin;
			},
			show: ["Imports"].includes(type),
		},
		{
			Header: "Entity",
			id: 'entity',
			width: 250,
			//accessor: "customers.name_first|locations_related_by_internal.name_display|locations_related_by_internal.name|dealers.name_display|dealers.name_company",
			accessor: object => {
				/**
				 * @type {Transactions_Collections_Object} obj
				 */
				let obj = object;
				if (obj.internal && obj.locations_related_by_internal)
					return obj.locations_related_by_internal.name_display || obj.locations_related_by_internal.name;
				if (obj.customer && obj.customers)
					return obj.customers ? `${obj.customers.name_first} ${obj.customers.name_last}` : '';
				if (obj.dealer && obj.dealers)
					return (obj.dealers.name_display || obj.dealers.name_company) + ' (' + obj.dealers.ffl + ')';
				if (obj.exporter && obj.exports)
					return obj.exports.name;
				if (obj.legal_entity && obj.legal_entities)
					return obj.legal_entities.name;
				if (obj.importer && obj.importers)
					return obj.importers.name;
				return '';
			},
			show: !["Destroyed", "Losses"].includes(type),
			Cell: props => {
				/**
				 * @typedef {object} props
				 * @property {Transactions_Collections_Object} original
				 */
				if (props.original.internal && props.original.locations_related_by_internal)
					return <Link
						to={"/locations/" + props.original.internal_binary_id + '-' + props.original.internal}>{props.original.locations_related_by_internal.name_display || props.original.locations_related_by_internal.name}</Link>;

				if (props.original.customer && props.original.customers) {
					let middleName = props.original.customers.name_middle && props.original.customers.name_middle !== '' && props.original.customers.name_middle.toLowerCase() !== 'nmn' ? (props.original.customers.name_middle + ' ' ) : '';
					return (
						<Link to={`/customers/${getFullID(props.original, 'customer')}`}>
							{props.original.customers ? `${props.original.customers.name_first} ${middleName}${props.original.customers.name_last}` : ''}
						</Link>
					);
				}

				if (props.original.dealer && props.original.dealers) {
					return (
						<Link
							to={`/dealers/${getFullID(props.original, 'dealer')}`}>
							{props.original.dealers.name_display || props.original.dealers.name_company} ({props.original.transaction_collections.dealer_ffl ?? props.original.dealers.ffl})
						</Link>
					)
				}
				if (props.original.importers) {
					return (
						<Link
							to={`/importers/${props.original.importers.binary_id}-${props.original.importers.pkey}`}>
							{props.original.importers.name} {props.original.importers.ffl !== "" ? ('(' + props.original.importers.ffl + ')') : ''}
						</Link>
					)
				}
				if (props.original.exporter && props.original.exports)
					return <Link
						to={"/exports/" + props.original.exporter_binary_id + '-' + props.original.exporter}>{props.original.exports.name}</Link>;

				if (props.original.legal_entity && props.original.legal_entities)
					return <Link
						to={"/legal_entities/" + props.original.legal_entity}>{props.original.legal_entities.name}</Link>;
				return null;
			}
		},
		{
			Header: "Serial Number",
			id: "serial_number",
			accessor: "serial_number",
			width: 220,
		},
		{
			Header: "Product",
			id: "product_type",
			/** @param {Transactions_Object} obj */
			accessor: (obj) => {
				return obj.product ? (obj.product_type + ' | ' + (obj.manufacturers ? obj.manufacturers.name : obj.manufacturer_other) + ' | ' + obj.model) : '';
			},
			Cell: props => {
				/**
				 * @typedef {object} props
				 * @property {Transactions_Object} original
				 */
				return (
					<Link to={`/products/${getFullID(props.original, 'product')}`}>
						{props.value}
					</Link>
				)
			}
		},
		{
			Header: "Notes",
			id: "notes",
			accessor: "notes",
			show: ["Destroyed", "Losses"].includes(type),
		},
		{
			Header: "Date",
			id: "date",
			width: 100,
			accessor: obj => {
				return moment(obj.date)
					.local()
					.format("MM/DD/YYYY")
			}
		},
		{
			Header: "Returned",
			id: "returned_date",
			width: 100,
			/** @param {Transactions_Object} obj */
			accessor: obj => {
				return obj.returned ? moment(obj.returned_date)
					.local()
					.format("MM/DD/YYYY") : ''
			},
			show: ["Reservations", "Rentals"].includes(type),
		},
		{
			Header: type === "Acquisitions" ? "Location/Bound Book" : 'Location',
			id: "location",
			width: 200,
			accessor: object => {
				/**
				 * @type {Transactions_Collections_Object} obj
				 */
				let obj = object;
				let name = obj.locations_related_by_location ? (obj.locations_related_by_location.name_display || obj.locations_related_by_location.name) : '';
				return name + (type === "Acquisitions" ? ' / ' + (obj.location_bound_books ? obj.location_bound_books.name : obj.locations_related_by_location.bound_book) : '');
			},
			Cell: props => (
				<Link to={`/locations/${getFullID(props.original, 'location')}`}>
					{props.value}
				</Link>
			)
		},
	];

	tableButtons = (type, url) => [
		{
			Header: 'Generated 4473',
			className: "button-cell",
			accessor: 'pkey',
			width: 140,
			show: type === "Dispositions",
			filterable: false,
			sortable: false,
			Cell: props => {
				let form_pkey = '';
				if(props.original.transaction_collections.has_combined === true) {
					let combined_form = props.original.forms.filter(form => form.results.includes('on_server'));
					let created;
					if(typeof combined_form === 'object') {
						created = (combined_form[0].created)
					}
					else {
						created = combined_form.created
					}
					return (
						<span>
							<a target={'_blank'}
							   href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/combined_form?location=${props.original.transaction_collections.location}&created=${created}`}>
								<Button outline={true} color={'secondary'} size={"sm"} block={true}>
									<i className={"fa fa-file-pdf-o"}/> Form 4473</Button>
							</a>
						</span>
					)
				}
				else {
					return (
						<span>
							{props.original.forms.filter(
								ms => {
									let qualifies = (ms.form === 1 || ms.form === 5 || ms.form === 7 || ms.form === 8 || ms.form === 14 || ms.form === 16|| ms.form === 21 || ms.form === 22 || ms.form === 24 || ms.form === 25);
									if (qualifies) {
										form_pkey = ms.binary_id + '-' + ms.pkey;
									}
									return qualifies
								}).length > 0 &&
							<a target={'_blank'}
							   href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/transactions/" + props.original.collection_binary_id + '-' + props.original.collection + '/collections_forms/' + form_pkey}>
								<Button outline={true} color={'secondary'} size={"sm"} block={true}>
									<i className={"fa fa-file-pdf-o"}/> Form 4473</Button>
							</a>}
						</span>
					);
				}
			}
		},
		{
			Header: 'Multiple Sale',
			className: "button-cell",
			accessor: 'pkey',
			width: 130,
			show: type === "Dispositions",
			filterable: false,
			sortable: false,
			/**
			 * @param  {Transactions_Object} props.original
			 */
			Cell: props => {
				let form_pkey = '';
				return (
					<span>
						{props.original.forms.filter(
							ms => {
								let qualifies = (ms.form === 3);
								if (qualifies) {
									form_pkey = ms.binary_id + '-' + ms.pkey;
								}
								return qualifies
							}).length > 0 &&
						<a target={'_blank'}
						   href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/transactions/" + props.original.collection_binary_id + '-' + props.original.collection + '/collections_forms/' + form_pkey}>
							<Button outline={true} color={'secondary'} size={"sm"} block={true}>
								<i className={"fa fa-file-pdf-o"}/> Form 3310.4</Button>
						</a>}
					</span>
				);
			}
		},
		{
			Header: 'Certain Rifles',
			className: "button-cell",
			accessor: 'pkey',
			width: 130,
			show: type === "Dispositions",
			filterable: false,
			sortable: false,
			/**
			 * @param  {Transactions_Object} props.original
			 */
			Cell: props => {
				let form_pkey = '';
				return (
					<span>
						{props.original.forms.filter(
							ms => {
								let qualifies = (ms.form === 2);
								if (qualifies) {
									form_pkey = ms.binary_id + '-' + ms.pkey;
								}
								return qualifies
							}).length > 0 &&
						<a target={'_blank'}
						   href={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/transactions/" + props.original.collection_binary_id + '-' + props.original.collection + '/collections_forms/' + form_pkey}>
							<Button outline color={'secondary'} size={"sm"} block={true}>
								<i className={"fa fa-file-pdf-o"}/> Form 3310.12</Button>
						</a>}
					</span>
				);
			}
		},
		{
			Header: "",
			className: "button-cell",
			filterable: false,
			sortable: false,
			width: 40,
			Cell: props => {
				return (
					<span>
						<Link to={`/${url}/${getFullID(props.original, 'collection')}`}>
							<Button color="green-meadow" size={"sm"} block={true}>
								<i className={"fa fa-pencil"}/></Button>
						</Link>
					</span>
				);
			}
		}
	];

	render(type, url, entity, extraColumns) {
		const {showDateRangeSearch} = this.props;
		const {data, pages, limit, loading, expanded, columnsAnchor} = this.state;
		extraColumns = typeof extraColumns !== 'undefined' && extraColumns ? extraColumns : [];
		let columns = [
			...this.tableColumns(type, url),
			...extraColumns,
			...this.tableButtons(type, url)
		];
		return (
			<div className="box-body">
				<div className="table-bar">
					<div className="d-flex">
						{this.renderSearch(type)}
						{this.renderLocationFilter()}
						{showDateRangeSearch ? this.renderDateRangeSearch() : null}
						{this.renderHeaderRight(type, columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose)}
					</div>
				</div>
				<ReactTable
					key={this.state.key}
					columns={columns}
					manual // Forces table not to paginate or sort automatically, so we can handle it server-side
					data={data}
					pages={pages} // Display the total number of pages
					loading={loading} // Display the loading overlay when we need it
					loadingText="Requesting Data"
					onFetchData={this.fetchData} // Request new data when things change
					onPageSizeChange={this.onPageSizeChange}
					onSortedChange={this.onSortedChange}
					page={this.state.page}
					onPageChange={this.onPageChange}
					expanderDefaults={{
						sortable: true,
						resizable: true,
						filterable: false,
						width: undefined
					}}
					expanded={expanded}
					onExpandedChange={this.onExpandedChange}
					defaultSorted={[
						{
							id: this.model.sort,
							desc: this.model.order === 'desc'
						}
					]}
					showPagination={true}
					showPaginationTop={false}
					showPaginationBottom={true}
					showPageSizeOptions={true}
					defaultPageSize={limit}
					pageSize={limit}
					pageSizeOptions={[5, 20, 50, 100, 500, 1000]}

					className="-striped -highlight"
				/>
				{/*<UniversalModalOverride*/}
				{/*	name={"Product"}*/}
				{/*	locations={this.props.locations}*/}
				{/*	states={this.props.states}*/}
				{/*	history={this.props.history}*/}
				{/*	id={this.state.code ? this.state.code.barcode : null}*/}
				{/*	objectProps={{*/}
				{/*		params: {*/}
				{/*			id: this.state.code ? (this.state.code.prefix + '-' + this.state.code.barcode) : null*/}
				{/*		}*/}
				{/*	}}*/}
				{/*	object={Objects.ProductUpdate}*/}
				{/*	toggle={this.state['modalProduct']}*/}
				{/*	reportClose={this.reportClose('modalProduct')}*/}
				{/*	size={"xl"}*/}
				{/*/>*/}
			</div>
		)
	}

}
